import React, { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { ROUTES } from '../routing/routes';
import Footer from './footer/footer';
import Header from './header/header';

interface ILayout {
  children: ReactNode;
}

const Layout = (props: ILayout) => {
  const { children } = props;
  const location = useLocation();

  const showHeader = () =>
    ROUTES.LOGIN !== location.pathname &&
    ROUTES.FORGOT_PASSWORD !== location.pathname &&
    !location.pathname.includes('/reset-password');

  return (
    <>
      {showHeader() && <Header />}
      <main>{children}</main>
      {showHeader() && <Footer />}
    </>
  );
};

export default Layout;
